var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material-popup-container"},[_c('div',{staticClass:"d-flex flex-column position-relative material-popup-info-container justify-content-center",style:({backgroundImage: 'url(' + _vm.product.foto + ')'})},[_c('span',{style:({background: _vm.color})},[_vm._v(".Pdf")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }